export const CONNECTED = "connected";
export const ENDED = "ended";
